import { render, staticRenderFns } from "./Devize_draft.vue?vue&type=template&id=c4874330&scoped=true&"
import script from "./Devize_draft.vue?vue&type=script&lang=js&"
export * from "./Devize_draft.vue?vue&type=script&lang=js&"
import style0 from "./Devize_draft.vue?vue&type=style&index=0&id=c4874330&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4874330",
  null
  
)

export default component.exports